import { render, staticRenderFns } from "./InvalidGoods.vue?vue&type=template&id=e7453ada&scoped=true"
import script from "./InvalidGoods.vue?vue&type=script&lang=js"
export * from "./InvalidGoods.vue?vue&type=script&lang=js"
import style0 from "./InvalidGoods.vue?vue&type=style&index=0&id=e7453ada&prod&lang=scss&scoped=true"
import style1 from "./InvalidGoods.vue?vue&type=style&index=1&id=e7453ada&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7453ada",
  null
  
)

export default component.exports